import {
  ClanMissionType,
  IClanMemberMissionProgress,
  IClanMission,
  IClanMissionProgress
} from "."
import { IResPag } from "utils/types"
import { IPaginationReq } from "utils/interfaces"
import { TAGS, api } from "../../api"
import { missionsEndpoints } from "../missionsAPI"

const basePath = "/clan-missions"

export const clanMissionsApi = api.enhanceEndpoints({
  addTagTypes: [TAGS.CLAN_MISSIONS, TAGS.MISSIONS, TAGS.POINTS_LEADERBOARD]
})

export const clanMissionsEndpoints = clanMissionsApi.injectEndpoints({
  endpoints: (builder) => ({
    getClanMissions: builder.query<IResPag<IClanMission>, IPaginationReq>({
      query: (params) => {
        return {
          url: `${basePath}`,
          method: "GET",
          params
        }
      },
      providesTags: (_, __, { page, limit }) => [
        { type: TAGS.CLAN_MISSIONS, id: `LIST` },
        { type: TAGS.CLAN_MISSIONS, id: `LIST:page:${page}:limit:${limit}` }
      ]
    }),
    getClanMissionsByType: builder.query<IClanMission[], ClanMissionType>({
      query: (missionType) => ({
        url: `${basePath}/type/${missionType}`,
        method: "GET"
      }),
      providesTags: (_, __, missionType) => [
        { type: TAGS.CLAN_MISSIONS, id: `MISSION:${missionType}` }
      ]
    }),
    getMyClanMissionProgress: builder.query<IClanMissionProgress[], void>({
      query: () => ({
        url: `${basePath}/clan-progress`,
        method: "GET"
      }),
      providesTags: () => [{ type: TAGS.CLAN_MISSIONS, id: "MY_PROGRESS" }]
    }),
    getMyClanMemberMissionProgress: builder.query<
      IClanMemberMissionProgress[],
      void
    >({
      query: () => ({
        url: `${basePath}/me/progress`,
        method: "GET"
      }),
      providesTags: () => [{ type: TAGS.CLAN_MISSIONS, id: "MY_PROGRESS" }]
    }),

    claimClanMission: builder.mutation<void, IClanMission>({
      query: (mission) => ({
        url: `${basePath}/${mission._id}/claim`,
        method: "PATCH"
      }),
      invalidatesTags: () => [
        { type: TAGS.MISSIONS, id: "HAS_UNCLAIMED" },
        { type: TAGS.POINTS_LEADERBOARD, id: "LIST" }
      ],
      onQueryStarted: async (mission, { queryFulfilled, dispatch }) => {
        await queryFulfilled

        dispatch(
          missionsEndpoints.util.updateQueryData(
            "getMyPointsBalance",
            undefined,
            (draft) => {
              if (!draft) {
                return {
                  _id: "",
                  createdAt: "",
                  updatedAt: "",

                  userId: "",
                  value: mission.points,
                  total: mission.points
                }
              }

              draft.value += mission.points
              draft.total += mission.points
            }
          )
        )

        dispatch(
          clanMissionsEndpoints.util.updateQueryData(
            "getMyClanMemberMissionProgress",
            undefined,
            (draft) => {
              if (!draft) return

              const missionItem = draft.find(
                (item) => item.missionId === mission._id
              )

              if (!missionItem) return

              missionItem.isClaimed = true
              missionItem.claimedAt = new Date().toISOString()
            }
          )
        )
      }
    })
  })
})

export const {
  useClaimClanMissionMutation,
  useGetClanMissionsByTypeQuery,
  useGetClanMissionsQuery,
  useGetMyClanMissionProgressQuery,
  useGetMyClanMemberMissionProgressQuery
} = clanMissionsEndpoints
